<template>
  <div id="logos">
    <h1>{{ pageTitle }}</h1>
    <p>The logo files below all have transparent backgrounds. The backgrounds shown here are for visibility only.</p>
    <div class="columns">
        <logo bg="graybg" fileName="Tekstur-Logo-Light-No-Tagline"></logo>
        <logo bg="graybg" fileName="Tekstur-Logo-Light"></logo>
        <logo bg="whitebg" fileName="Tekstur-Logo-Dark-No-Tagline"></logo>
    </div>
    <div class="columns">
        <logo bg="whitebg" fileName="Tekstur-Logo-Dark"></logo>
        <logo bg="bluebg" fileName="Tekstur-Logo-All-White-No-Tagline"></logo>
        <logo bg="lightgraybg" fileName="Tekstur-Logo-All-Black-No-Tagline"></logo>
    </div>
    <div class="columns">
      <div class="column">
        <p><a href="/img/logos/all-tekstur-logos.zip" class="button is-primary is-large is-fullwidth" download><font-awesome-icon class="fa-fw" icon="download" /> Download All</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  components: {
    Logo
  },
  data () {
    return {
      pageTitle: 'Logos'
    }
  }
}
</script>
